export default __webpack_public_path__ + "images/7G.2cf6943.png";